/* eslint-disable no-console */

import { register } from 'register-service-worker';

import store from './store';

if (process.env.NODE_ENV === 'production') {
  register(`${process.env.BASE_URL}service-worker.js`, {
    ready() {
      console.log('App is being served from cache by a service worker.\n' +
        'For more details, visit https://goo.gl/AFskqB');
    },
    cached() {
      console.log('Content has been cached for offline use.');
      store.commit('addToast', {
        content: 'Prt Mny has been fully downloaded and will be available offline from now on.',
        color: 'positive',
        timeout: 5000,
      });
    },
    updated(registration) {
      console.log('New content is available; please refresh.');
      store.dispatch('setForceChangelog', true)
        .then(() => {
          store.commit('addToast', {
            content: 'Prt Mny has been updated. Please refresh to see the changes.',
            color: 'positive',
            action: 'Reload',
            timeout: 5000,
            callback: () => {
              if (!registration.waiting) return;
              registration.waiting.postMessage('skipWaiting');
              window.location.reload();
            },
          });
        });
    },
    offline() {
      console.log('No internet connection found. App is running in offline mode.');
    },
    error(error) {
      console.error('Error during service worker registration:', error);
      store.commit('addToast', {
        content: `There was an error registering the service worker: ${error.message}`,
        color: 'negative',
        timeout: 5000,
      });
    },
  });
}
